import { Injectable, computed, inject, signal } from '@angular/core';
import { PromotionsApiService } from '../api/promotions-api.service';
import { DiscountResponseDto } from '../api/promotions-api.types';
import { descuentoADto, dtoADescuento } from '../api/promotions.mapper';
import { Descuento, DescuentoFormValue, SucursalDescuento } from '../models/promociones.model';
import { CatalogoProductosService } from './catalogo-productos.service';
import { SucursalesService } from './sucursales.service';

@Injectable({ providedIn: 'root' })
export class DescuentosService {
  private api = inject(PromotionsApiService);
  private sucursalesService = inject(SucursalesService);
  private readonly catalogo = inject(CatalogoProductosService);

  readonly categorias = this.catalogo.categorias;

  private readonly descuentosDto = signal<DiscountResponseDto[]>([]);
  readonly descuentos = computed<Descuento[]>(() =>
    this.descuentosDto().map((d) => dtoADescuento(d, this.categorias())),
  );

  readonly descuentosActivos = computed(() => this.descuentos().filter((d) => d.activo));
  readonly descuentosInactivos = computed(() => this.descuentos().filter((d) => !d.activo));

  constructor() {
    this.cargar();
  }

  cargar(): void {
    this.api.listarDescuentos().subscribe({
      next: (lista) => this.descuentosDto.set(lista),
      error: (error) => console.error('[Promociones] No se pudieron cargar los descuentos', error),
    });
  }

  sucursalesPorDefecto(): SucursalDescuento[] {
    return this.sucursalesService.paraDescuento();
  }

  obtenerPorId(id: string): Descuento | undefined {
    return this.descuentos().find((d) => d.id === id);
  }

  crear(form: DescuentoFormValue): void {
    this.api.crearDescuento(descuentoADto(form)).subscribe({
      next: () => this.cargar(),
      error: (error) => console.error('[Promociones] No se pudo crear el descuento', error),
    });
  }

  actualizar(id: string, form: DescuentoFormValue): void {
    this.api.actualizarDescuento(id, descuentoADto(form)).subscribe({
      next: () => this.cargar(),
      error: (error) => console.error('[Promociones] No se pudo actualizar el descuento', error),
    });
  }

  cambiarEstado(id: string, activo: boolean): void {
    this.descuentosDto.update((lista) =>
      lista.map((d) => (String(d.id) === id ? { ...d, active: activo } : d)),
    );

    this.api.cambiarEstadoDescuento(id, activo).subscribe({
      next: () => this.cargar(),
      error: (error) => {
        console.error('[Promociones] No se pudo cambiar el estado del descuento', error);
        this.cargar();
      },
    });
  }

  eliminar(id: string): void {
    this.api.eliminarDescuento(id).subscribe({
      next: () => this.cargar(),
      error: (error) => console.error('[Promociones] No se pudo eliminar el descuento', error),
    });
  }
}
